'use strict';

module.exports = require('./index').default;


//////////////////
// WEBPACK FOOTER
// ./~/requestanimationframe-timer/dist/cjs.js
// module id = 323
// module chunks = 35783957827783